(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var textarea = document.getElementById('ContactForm-body');
    if (!textarea) return;
    function grow() {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
    textarea.style.overflow = 'hidden';
    textarea.addEventListener('input', grow);
    grow();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // Respect the image size chosen in the admin editor: the editor writes it
  // into the width attribute, the stylesheet reads it as --article-img-width.
  (function () {
    function applyImageWidths(root) {
      root.querySelectorAll('.article-template__content img[width]').forEach(function (img) {
        var width = parseInt(img.getAttribute('width'), 10);
        if (width > 0) img.style.setProperty('--article-img-width', width + 'px');
      });
    }
    applyImageWidths(document);
    document.addEventListener('shopify:section:load', function (event) {
      applyImageWidths(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotation-category-links"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      // Touch detection: any device where hover isn't reliable.
      // We use click-to-toggle instead of CSS hover.
      var isTouch = window.matchMedia('(hover: none)').matches || 'ontouchstart' in window;

      var wrappers = document.querySelectorAll('[data-rot-cat-wrapper]');
      wrappers.forEach(function (wrapper) {
        if (wrapper.dataset.rotCatInit) return;
        wrapper.dataset.rotCatInit = '1';

        var trigger = wrapper.querySelector('[data-rot-cat-trigger]');
        if (!trigger) return;

        if (isTouch) {
          trigger.addEventListener('click', function (e) {
            // On touch devices, first tap opens accordion instead of navigating.
            // User taps a sub-item to actually navigate.
            e.preventDefault();
            e.stopPropagation();

            var isOpen = wrapper.hasAttribute('data-rot-cat-open');

            // Close any other open dropdowns.
            document.querySelectorAll('[data-rot-cat-wrapper][data-rot-cat-open]').forEach(function (w) {
              w.removeAttribute('data-rot-cat-open');
              var t = w.querySelector('[data-rot-cat-trigger]');
              if (t) t.setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
              wrapper.setAttribute('data-rot-cat-open', '');
              trigger.setAttribute('aria-expanded', 'true');
            }
          });
        }
      });

      // Outside-tap closes any open dropdown (touch devices only — desktop relies on hover-out).
      if (isTouch) {
        document.addEventListener('click', function (e) {
          document.querySelectorAll('[data-rot-cat-wrapper][data-rot-cat-open]').forEach(function (w) {
            if (!w.contains(e.target)) {
              w.removeAttribute('data-rot-cat-open');
              var t = w.querySelector('[data-rot-cat-trigger]');
              if (t) t.setAttribute('aria-expanded', 'false');
            }
          });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotation-sell-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rot-faq-link--anchor').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotation-sell-intro"] && !Shopify.designMode) return;
  try {
    
  // Smooth-scroll anchor links on the 3 nav buttons.
  document.querySelectorAll('.rotation-sell-intro__btn[href^="#"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // Right-column image carousel — only initialized when 2+ images.
  document.querySelectorAll('.rotation-sell-intro__media--carousel').forEach(function(carousel) {
    var slider = carousel.querySelector('[data-rot-sell-slider]');
    var prevBtn = carousel.querySelector('[data-rot-sell-prev]');
    var nextBtn = carousel.querySelector('[data-rot-sell-next]');
    var dots = carousel.querySelectorAll('[data-rot-sell-dot]');
    var slides = carousel.querySelectorAll('.rotation-sell-intro__slide');
    if (!slider || slides.length < 2) return;

    function currentIndex() {
      return Math.round(slider.scrollLeft / slider.clientWidth);
    }
    function goTo(index) {
      var clamped = Math.max(0, Math.min(slides.length - 1, index));
      slider.scrollTo({ left: clamped * slider.clientWidth, behavior: 'smooth' });
    }
    function updateUi() {
      var idx = currentIndex();
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
      if (prevBtn) prevBtn.toggleAttribute('disabled', idx === 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', idx === slides.length - 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex() + 1); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.dataset.rotSellDot, 10));
      });
    });

    var scrollTimer = null;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateUi, 80);
    });
    updateUi();
  });

  } catch(e) { console.error(e); }
})();
})();
